module.exports = __webpack_public_path__ + "img/UI_common_framelabelFX_01_afafa836f.png";